'use client';

import React from 'react';
import AppLayout from '@/components/AppLayout';
import InventoryAddHeader from './components/InventoryAddHeader';
import InventoryAddForm from './components/InventoryAddForm';

export default function InventoryAddItemsPage() {
  return (
    <AppLayout>
      <div className="flex flex-col h-full min-h-screen">
        <InventoryAddHeader />
        <InventoryAddForm />
      </div>
    </AppLayout>
  );
}
